module.exports = __webpack_public_path__ + "img/chrome.3d642fb6.svg";